module.exports = __webpack_public_path__ + "img/water_droplet_5.eb73cb24.svg";